import {Dialog, DialogBody, DialogTitle} from "@/components/tailwind/dialog";
import {Button} from "@/components/tailwind/button";
import {MemberListItem} from "@/models/member";
import {memberColumns} from "@/pages/members/member-columns";
import {MemberDataTable} from "@/pages/members/member-data-table";
import {ColumnDef} from "@tanstack/react-table";
import {useState} from "react";
import {Input, InputGroup} from "@/components/tailwind/input";
import {MagnifyingGlassIcon} from "@heroicons/react/16/solid";

interface MemberSelectDialogProps {
    isOpen: boolean;
    onClose: () => void;
    onSelect: (member: MemberListItem) => void;
    members: MemberListItem[];
    title: string;
    excludeMemberId?: string;
}

// FIXME i18n
function MemberSelectDialog({
                                isOpen,
                                onClose,
                                onSelect,
                                members,
                                title,
                                excludeMemberId
                            }: MemberSelectDialogProps) {
    const [searchTerm, setSearchTerm] = useState("");

    const displayMembers = excludeMemberId
        ? members.filter(m => m.id !== excludeMemberId)
        : members;

    const selectColumns: ColumnDef<MemberListItem>[] = [
        ...memberColumns.filter(col => col.id !== "actions"),
        {
            id: "actions",
            cell: ({ row }) => {
                const member = row.original;
                return (
                    <Button
                        onClick={() => onSelect(member)}
                        aria-label={`${member.firstName} ${member.lastName} auswählen`}
                        data-testid="member-select-button"
                    >
                        Auswählen
                    </Button>
                );
            }
        }
    ];

    // Reset search when dialog closes
    const handleClose = () => {
        setSearchTerm("");
        onClose();
    };

    return (
        <Dialog size="4xl" open={isOpen} onClose={handleClose} data-testid="member-select-dialog">
            <DialogTitle>{title}</DialogTitle>

            <DialogBody>
                <div className="mb-4">
                    <InputGroup>
                        <MagnifyingGlassIcon />
                        <Input
                            type="text"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            placeholder="Suche nach Name, Nummer, Adresse oder Firma..."
                            autoFocus
                            data-testid="member-select-search"
                        />
                    </InputGroup>
                </div>

                <div className="relative overflow-x-auto">
                    <MemberDataTable
                        columns={selectColumns}
                        data={displayMembers}
                        searchTerm={searchTerm}
                        data-testid="member-select-table"
                    />
                </div>

                <div className="mt-6 flex justify-end">
                    <Button outline onClick={handleClose} data-testid="member-select-cancel">
                        Abbrechen
                    </Button>
                </div>
            </DialogBody>
        </Dialog>
    );
}

export default MemberSelectDialog;
